import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import MediaCache from './media-cache-model'
import {
  CreateMediaCacheAsync,
  DeleteMediaCacheAsync,
  LoadMediaCachesAsync,
} from './mediaCache-thunk'
const initialState: mediaCacheSliceState = {
  mediaCache: [],
  selected_mediaCache: '',
  is_loading_mediaCache: false,
  is_creating_mediaCache: false,
  is_deleting_mediaCache: false,
}
export interface mediaCacheSliceState {
  mediaCache: MediaCache[]
  selected_mediaCache?: string
  is_loading_mediaCache: boolean
  is_creating_mediaCache: boolean
  is_deleting_mediaCache: boolean
}
export const mediaCacheSlice = createSlice({
  name: 'mediaCache',
  initialState,
  reducers: {
    setSelectedmediaCache: (state, action) => {
      state.selected_mediaCache = action.payload
    },
    clearStatemediaCache: (state) => {
      state.mediaCache = []
      state.is_loading_mediaCache = false
      state.is_creating_mediaCache = false
      state.is_deleting_mediaCache = false
    },
    mergemediaCache: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_mediaCache = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.mediaCache = merge(state.mediaCache, payload) as any
        }
      }
    },

    add_mediaCache: (state, action) => {
      if (action.payload) {
        state.mediaCache = [...state.mediaCache, action.payload]
      }
    },
    set_mediaCache: (state, action) => {
      let { key, value, id } = action.payload
      state.mediaCache = state.mediaCache.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMediaCachesAsync.pending, (state) => {
      state.is_loading_mediaCache = true
    })
    builder.addCase(LoadMediaCachesAsync.fulfilled, (state, action) => {
      state.is_loading_mediaCache = false
      if (action.payload) {
        state.mediaCache = action.payload
      }
    })
    builder.addCase(LoadMediaCachesAsync.rejected, (state) => {
      state.is_loading_mediaCache = false
    })
    builder.addCase(CreateMediaCacheAsync.pending, (state) => {
      state.is_creating_mediaCache = true
    })
    builder.addCase(CreateMediaCacheAsync.fulfilled, (state) => {
      state.is_creating_mediaCache = false
    })
    builder.addCase(CreateMediaCacheAsync.rejected, (state) => {
      state.is_creating_mediaCache = false
    })
    builder.addCase(DeleteMediaCacheAsync.pending, (state) => {
      state.is_deleting_mediaCache = true
    })
    builder.addCase(DeleteMediaCacheAsync.fulfilled, (state, action) => {
      state.is_deleting_mediaCache = false
      if (state.mediaCache) {
        state.mediaCache = state.mediaCache.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteMediaCacheAsync.rejected, (state) => {
      state.is_deleting_mediaCache = false
    })

    builder.addCase(autoThunks.load_cache_media_urls.pending, (state) => {
      state.is_loading_mediaCache = true
    })
    builder.addCase(
      autoThunks.load_cache_media_urls.fulfilled,
      (state, action) => {
        state.is_loading_mediaCache = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.load_cache_media_urls.rejected, (state) => {
      state.is_loading_mediaCache = false
    })
  },
})

function handleResult(action: any, state: mediaCacheSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_mediaCache = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.mediaCache = merge(state.mediaCache, payload) as any
    }
  }
}

export const {
  clearStatemediaCache,
  setSelectedmediaCache,
  set_mediaCache,
  mergemediaCache,
  add_mediaCache,
} = mediaCacheSlice.actions

export const get_mediaCache =
  (id?: string) =>
  (state: {
    mediaCache: {
      mediaCache: MediaCache[]
    }
  }): MediaCache | null => {
    let temp = state?.mediaCache?.mediaCache?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.mediaCache?.mediaCache[0] || null
  }
export const get_selected_mediaCache = (state: {
  mediaCache: mediaCacheSliceState
}): MediaCache | null => {
  let id = state?.mediaCache?.selected_mediaCache
  let temp = state?.mediaCache?.mediaCache?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_mediaCache = (state: {
  mediaCache: {
    mediaCache: MediaCache[]
  }
}): MediaCache[] => {
  let temp = state?.mediaCache?.mediaCache
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_mediaCache_busy = (state: {
  mediaCache: mediaCacheSliceState
}) => {
  return (
    state?.mediaCache.is_deleting_mediaCache ||
    state?.mediaCache.is_loading_mediaCache ||
    state?.mediaCache.is_creating_mediaCache
  )
}
export const is_deleting_mediaCache_busy = (state: {
  mediaCache: mediaCacheSliceState
}) => {
  return state?.mediaCache.is_deleting_mediaCache
}
export const is_loading_mediaCache_busy = (state: {
  mediaCache: mediaCacheSliceState
}) => {
  return state?.mediaCache.is_loading_mediaCache
}
export const is_creating_mediaCache_busy = (state: {
  mediaCache: mediaCacheSliceState
}) => {
  return state?.mediaCache.is_creating_mediaCache
}

export default mediaCacheSlice.reducer
